import { type Table } from '@tanstack/react-table';
import { Download } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { generateCSV, downloadFile } from './utils';

interface DataTableExportProps<TData> {
  table: Table<TData>;
  filename?: string;
}

export function DataTableExport<TData>({
  table,
  filename = 'export',
}: DataTableExportProps<TData>) {
  const handleExport = () => {
    const csv = generateCSV(table);
    const timestamp = new Date().toISOString().split('T')[0];
    downloadFile(csv, `${filename}-${timestamp}.csv`);
  };

  return (
    <Button variant="outline" size="sm" className="h-9" onClick={handleExport}>
      <Download className="mr-2 h-4 w-4" />
      Export
    </Button>
  );
}
